import * as React from 'react'
import { Link } from 'react-router'

interface Props {
  name: string
  url: string
  location: any
  new?: boolean
}

export class ReportLink extends React.Component<Props, {}> {
  render() {
    const isSelected = window.location.pathname.includes(this.props.url)

    return (
      <div>
        {isSelected ? (
          <Link
            to={{
              pathname: this.props.url,
              query: this.props.location.query,
            }}
          >
            <b>{this.props.name}</b>
          </Link>
        ) : (
          <Link
            to={{
              pathname: this.props.url,
              query: this.props.location.query,
            }}
          >
            {this.props.name}
          </Link>
        )}
        {this.props.new && <span className='badge badge-success ml-2'>NEW</span>}
      </div>
    )
  }
}
